import { Controller } from 'stimulus';

const MAX_HEIGHT = 150;

export default class ExpandPreviewController extends Controller {
  connect() {
    const $element = $(this.element);
    $element.toggleClass('collapsed', $element.height() > MAX_HEIGHT);
  }

  expand() {
    $(this.element).toggleClass('collapsed', false);
  }
}
